module.exports = __webpack_public_path__ + "img/20171229_172022.790c4201.jpg";